import { useMutation } from "@tanstack/react-query";
import { request } from "../../utilities/axios-utils";

export const verifyOtpMutation = async (payload) => {
  const requestData = {
    passCode: payload.verificationCode
  }
  try {
    const response = await request({
      url: `/smsVerify`,
      method: "POST",
      data: JSON.stringify(requestData),
      accessToken: payload.accessToken,
    });
    return response;
  } catch (error) {
    console.error("Error fetching options:", error);
    // throw new Error(error.response.data);
    throw new Error(error);
  }
};

export const useVerifyOtpMutation = () => {
  return useMutation((payload) => verifyOtpMutation(payload));
};
